import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BannerCvComponent } from './banner-cv/banner-cv.component';
import { BannerPrincipalComponent } from './banner-principal/banner-principal.component';
import { BannerSecretariaTrabajoComponent } from './banner-secretaria-trabajo/banner-secretaria-trabajo.component';
import { BannerMypathComponent } from './banner-mypath/banner-mypath.component';
import { BannerSepComponent } from './banner-sep/banner-sep.component';

@NgModule({
  declarations: [
    BannerCvComponent,
    BannerPrincipalComponent,
    BannerSecretariaTrabajoComponent,
    BannerMypathComponent,
    BannerSepComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    BannerCvComponent,
    BannerPrincipalComponent,
    BannerSecretariaTrabajoComponent,
    BannerMypathComponent,
    BannerSepComponent
  ]
})
export class ComponentesModule { }
